/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { UtilsService } from 'app/shared/services';

@Component({
  selector: '[appModal]',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnDestroy, OnInit {
  @Input() showCloseButton = true;
  @Input() closeOnClickOutside = true;
  @Input() mainClass = 'small-modal';
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  constructor(private el: ElementRef, private utilsService: UtilsService, private renderer: Renderer2) {}

  ngOnInit() {
    this.utilsService.showPageModal();
  }

  ngOnDestroy() {
    this.utilsService.hidePageModal();
  }

  close(isCancelled: boolean, $event: Event = null) {
    if ($event) {
      $event.preventDefault();
    }

    // close modal without emitting new value
    if (isCancelled) {
      this.closeModal.emit();
    }
  }

  clickedOutside() {
    if (!this.closeOnClickOutside) {
      return;
    }

    this.close(true);
  }
}
